import sweetRouter from '@mtfe/sweet-router';
import { dom, eventBus, container } from '@mtfe/sweet-utils';
import { oadLX } from '@mtfe/pr-oad';
import { ErrorPage } from '@mtfe/sweet-components';

import getRouterConfig from './router/index';
import { initUserInfo, invokeReportLog } from './utils';
import { ERROR_TEXT } from './constants';
import { hideSkeleton, showSkeleton } from './utils/dom';
import { oadForceMiniProgramLogin } from './utils/autoLogin';
import './utils/loadVConsole';
import { addPageError } from './utils/report';

const { isInTuanApp, isInWaiMaiApp } = container;
// 强制同步小程序用户态
oadForceMiniProgramLogin();

const App = async () => {
    try {
        eventBus.clearAllEvent();
        dom.$id('searchBar').innerHTML = '';
        dom.$id('index').innerHTML = '';
        dom.$id('search').innerHTML = '';
        dom.$id('result').innerHTML = '';
        showSkeleton();

        // 初始化用户信息
        await initUserInfo();
        // 初始化路由
        const router = await getRouterConfig();
        await sweetRouter(router);
        eventBus.$onceOn('loginSuccess', () => {
            if (isInTuanApp || isInWaiMaiApp) {
                KNB &&
                    KNB.jumpPage({
                        url: window.location.href,
                    });
            } else {
                window.location.reload();
            }
        });
    } catch (error) {
        addPageError('v7页面错误');
        const errorText = error.message || ERROR_TEXT;
        hideSkeleton();
        dom.$id('app').innerHTML = ErrorPage({ text: errorText, oadLX });
        console.error(error);
    } finally {
        // 上报日志
        invokeReportLog();
    }
};

App();
